import { blocks, constraints } from '@yola/ws-sdk';
import ai from 'src/js/modules/ai';

const {
  helpers: { initiateBlockGeneration },
} = ai;
const IMAGE_ELEMENT_SELECTOR =
  'ws-media-container:not([placeholder]) img, ws-block[background-image]:not([background-hidden]):not([background-placeholder]) ws-background-container';

const getRegeneratedBlockHtml = async (element, pageMeta, { layout, content }) => {
  const blockId = blocks.accessors.getBlockIdByElement(element);
  const blockVariationId = blocks.accessors.getVariationIdByElement(element);
  const rootTextSelector = constraints.accessors.getContentEditableRootSelector();
  const textElements = element.querySelectorAll(rootTextSelector.join(','));
  const blockTextContent = [...textElements].map((el) => el.innerText).join(' ');
  const options = [];
  const usedImageSources = [...element.querySelectorAll(IMAGE_ELEMENT_SELECTOR)]
    .map((el) => el.getAttribute('src'))
    .filter((source) => !!source);

  if (layout) options.push('layout');
  if (content) options.push('content');

  try {
    const response = await initiateBlockGeneration({
      blockId,
      blockVariationId,
      options,
      pageMeta,
      blockTextContent,
      ...(usedImageSources.length && { usedImageSources }),
    });

    const { html } = response.results;

    return html;
  } catch (e) {
    throw e;
  }
};

export default getRegeneratedBlockHtml;
